import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr'; // Adjust path as needed
import { ChecklistDialogComponent } from './O3AdministrationComponents/ManufacturingAdminComponents/preventive-maintanance-configuration/checklist-dialog/checklist-dialog.component';
import { ParamaterDialogComponent } from './O3AdministrationComponents/ManufacturingAdminComponents/preventive-maintanance-configuration/paramater-dialog/paramater-dialog.component';

@Component({
  selector: 'btn-cell-renderer',
  template: `
    <style>
      .edit-btn {
        color: white;
        background: #3aafe4;
        margin-right: 5px;
      }
      .del-btn {
        color: white;
        background: red;
        margin-right: 5px;
      }
      .history-btn {
        color: white;
        background: #19acab;
        margin-right: 5px;
      }
      .parameter-btn {
        color: white;
        background: #4caf50;
        margin-right: 5px;
      }
      i {
        color: white;
      }
      .btn:disabled {
        opacity: 0.5;
      }
      .btn {
        border: none;
        border-radius: 20px;
        cursor: pointer;
      }
      .config-btns {
        display: flex;
      }
    </style>
    <div class="config-btns">
      <button
        class="edit-btn btn"
        [disabled]="!params.data.IsWrite"
        mat-icon-button
        title="Edit"
        (click)="onClickEdit($event)"
      >
        <i
          class="fa fa-pencil-square-o"
          aria-hidden="true"
          style="padding:9px;font-size:18px;"
        ></i>
      </button>
      <button
        class="del-btn btn"
        title="Delete"
        [disabled]="!params.data.IsWrite || params?.data?.IsDelete == 0"
        mat-icon-button
        (click)="onClickDelete($event)"
      >
        <i
          class="fa fa-trash"
          aria-hidden="true"
          style="padding:9px;font-size:18px;"
        ></i>
      </button>
      <button
        class="history-btn btn"
        title="View Task History"
        [disabled]="!params.data.IsWrite"
        mat-icon-button
        (click)="onClickHistory($event)"
      >
        <i
          class="fa fa-history"
          aria-hidden="true"
          style="padding:9px; font-size:18px;"
        ></i>
      </button>
      <button
        class="parameter-btn btn"
        title="Add Parameters"
        [disabled]="!params.data.IsWrite"
        mat-icon-button
        (click)="onClickParameter($event)"
      >
        <i
          class="fa fa-cogs"
          aria-hidden="true"
          style="padding:9px;font-size:18px;"
        ></i>
      </button>
    </div>
  `,
})
export class ActionEditDeleteBtnRenderer
  implements ICellRendererAngularComp, OnDestroy
{
  params: any;

  constructor(private dialog: MatDialog, private toaster: ToastrService) {}

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }

  onClickEdit($event: any): void {
    if (this.params.onClickEdit instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
      };
      this.params.onClickEdit(params);
    }
  }

  onClickDelete($event: any): void {
    if (this.params.onClickDelete instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
      };
      this.params.onClickDelete(params);
    }
  }

  onClickHistory($event: any): void {
    if (this.params.onClickHistory instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex
      };
      this.params.onClickHistory(params);
    }
  }

  onClickParameter($event: any): void {
    if (this.params.onClickParameter instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
      };
      this.params.onClickParameter(params);
    }
  }

  ngOnDestroy(): void {
    // No need to remove button click handlers
  }
}
